// extracted by mini-css-extract-plugin
export default {"applicants":"style_applicants__IqUNC","close":"style_close__BrPwg","title":"style_title__ljRMK","appls":"style_appls__xAGn-"};